import { Container, Row, Col } from "react-bootstrap";
import itchIcon from "../assets/img/itchio-textless-white.svg";
import itchIconDark from "../assets/img/itchio-textless-white.svg";
import { GitHub, LinkedIn, Mail, Twitter } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
// import backTopImg from "../assets/img/backtopbutton3.png";

export const Footer = ({ theme }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  // const isMediaGreaterThan1300px = useMediaQuery({ minWidth: 1301 });

  // useEffect(() => {
  //   const adjustNavPillsParentRight = () => {
  //     const element = document.querySelector('.social-icon');
  //     if (element) {
  //       const screenWidth = window.innerWidth;
  //       let newLeftValue;
  //       if (screenWidth >= 1920) {
  //         newLeftValue = 7;
  //       } else if (screenWidth <= 1300) {
  //         newLeftValue = 3;
  //       } else {
  //         newLeftValue = 7 - ((7 - 3) * ((1920 - screenWidth) / (1920 - 1300)));
  //       }
  //       (element as HTMLElement).style.left = isMediaGreaterThan1300px ? `${newLeftValue}%` : "0";
  //     }
  //   };

  //   window.addEventListener("resize", adjustNavPillsParentRight);
  //   adjustNavPillsParentRight(); // Initial call to set the right value

  //   return () => window.removeEventListener("resize", adjustNavPillsParentRight);
  // }, []);

  return (
    <footer className="footer">
      <Container className={"width-base footer-container"}>
        <Row className="align-items-center footer-row">
          {/* <MailchimpForm /> */}
          <Col size={12} sm={6} md={6} lg={6} className="social-name no-padding">
            {/* <img id="logo-footer" src={logo} alt="Logo" /> */}

            <Link to="/" onClick={() => window.scrollTo(0, 0)} style={{ cursor: 'pointer' }}
              className={isMobile ? "navbar-brand footer-brand footer-mobile" : "navbar-brand footer-brand"}>
              {/* <img id='logo-img' src={logo} alt="Logo" /> */}
              <p className="logo-p">© 2025 Lucas Coutinho</p>
            </Link>
          </Col>
          <Col size={12} sm={6} md={6} lg={6} className="social-container no-padding">
            <div className={isMobile ? "social-icon social-icon-mobile" : "social-icon"}>
              <a href="mailto:contact@lucascoutinho.dev" target="_blank" rel="noopener noreferrer"><Mail /></a>
              <a href="https://linkedin.com/in/lucasctnh" target="_blank" rel="noopener noreferrer" ><LinkedIn /></a>
              <a href="https://github.com/lucasctnh" target="_blank" rel="noopener noreferrer"><GitHub /></a>
              <a href="https://lucasctnh.itch.io/" target="_blank" rel="noopener noreferrer">
                {theme === 'light' ? <img src={itchIcon} alt="Itch.io" /> : <img src={itchIconDark} alt="Itch.io" />}
              </a>
              <a href="https://x.com/lucas_ctnh" target="_blank" rel="noopener noreferrer"><Twitter /></a>
              {/* {isMediaGreaterThan1300px && (<div className="social-vertical-line"></div>)} */}
            </div>
          </Col>
          {/* {isMediaGreaterThan1300px && (
            <Col size={12} sm={4} className="text-center text-sm-end footer-navbar-container no-padding">
              <div className="footer-navbar">
                <a href="/about"> <p className="logo-p">About me</p> </a>
                <a href="/projects" > <p className="logo-p">Projects</p> </a>
                <a href="/contact"> <p className="logo-p">Contact</p> </a>
              </div>
            </Col>
          )} */}

          {/* <Col size={12} sm={4} className="text-center text-sm-end social-container no-padding">
            <div className={isMobile ? "social-icon social-icon-mobile" : "social-icon"}>
              <a href="mailto:contact@lucascoutinho.dev" target="_blank" rel="noopener noreferrer"><MailOutline /></a>
              <a href="https://linkedin.com/in/lucasctnh" target="_blank" rel="noopener noreferrer" ><LinkedIn /></a>
              <a href="https://github.com/lucasctnh" target="_blank" rel="noopener noreferrer"><GitHub /></a>
              <a href="https://lucasctnh.itch.io/" target="_blank" rel="noopener noreferrer">
                {theme === 'light' ? <img src={itchIcon} alt="Itch.io" /> : <img src={itchIconDark} alt="Itch.io" />}
              </a>
              <a href="https://x.com/lucas_ctnh" target="_blank" rel="noopener noreferrer"><Twitter /></a>
            </div>
          </Col> */}
        </Row>
      </Container>

      {/* <button className="back-top" style={{backgroundImage: `url(${backTopImg})`}} onClick={(e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }}>
        <ArrowBackIos />
      </button> */}

    </footer>
  )
}
